<template>
    <div>
    <div class="wrapper">
        <!-- Sidebar  -->
        <nav id="sidebar" :class="toggleSidebar">
            <div class="sidebar-header mb-0 pb-0">
                <h5 class="font-weight-bold ml-2 mb-4 pb-2">Moneypool </h5>
                <div class="card shadow-sm">
                    <div class="card-body px-3 py-3">
                        <p class="p-0 mb-1 font-weight-bold">My Name</p>
                        <h6 class="small">@username </h6>
                    </div>
                </div>
            </div>

            <ul class="list-unstyled components">
                <li class="">
                    <a> <span class="fas fa-tachometer-alt mr-3"> </span>Dashboard</a>
                </li>
                <li class="">
                    <a> <span class="fas fa-database mr-3"> </span>My Pools</a>
                </li>
                <li class="">
                    <a> <span class="fas fa-pen-alt  mr-3"> </span>Create Pool</a>
                </li>
                <li class="">
                    <a> <span class="fas fa-address-book  mr-3"> </span>Contacts</a>
                </li>
                <li class="">
                    <a> <span class="fas fa-credit-card  mr-3"> </span>Payouts</a>
                </li>
                <li class="">
                    <a> <span class="fa fa-user-circle  mr-3"> </span>My Account</a>
                </li>
                <li class="">
                    <a> <span class="fas fa-phone-square-alt  mr-3"> </span>Support</a>
                </li>
            </ul>
        </nav>

        <!-- Page Content  -->
        <div id="content">

            <!-- dashboard content area -->
            <div class="d-flex flex-column">

                <div class="container mb-5">

                    <slot></slot>
                    
                </div>
            </div>

        </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            sidebarActive: true,
        }
    },
    computed: {
        toggleSidebar() {
            return  {
                'active': this.sidebarActive == true,
                '' : this.sidebarActive == false
            }
        }
    },
    methods: {
        closeSidebar() {
          this.sidebarActive = this.sidebarActive ? false: true;
        }
    }
}
</script>

<style scoped>
@import '../assets/css/style-dashboard.css';

</style>